jQuery(document).ready(function ($) {
  var $single_gallery = $(".single-gallery");

  if (!$single_gallery.length) return;

  var single_gallery_more_images = new Swiper(
    ".single-gallery-more-images .swiper",
    {
      // allowTouchMove: false,
      spaceBetween: 10,
      navigation: {
        nextEl: $(".single-gallery .carousel-nav.next")[0],
        prevEl: $(".single-gallery .carousel-nav.prev")[0],
      },
    }
  );
});
